import React from 'react';
import ReactDOM from 'react-dom';

export enum INVESTMENT_PORTAL {
	SECTION_HEADER = '#investment-header-section-portal',
}

export const renderInvestmentSectionHeaderPortal = (children: React.ReactNode) => {
	const portalElement = document.getElementById(INVESTMENT_PORTAL.SECTION_HEADER);
	if (!portalElement) {
		return children;
	}
	return ReactDOM.createPortal(children, portalElement);
};
